import React, { useRef } from "react";
import HTMLFlipBook from "react-pageflip";

const NEWSLETTER_4_IMG = [
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_1.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_2.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_3.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_4.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_5.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_6.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_7.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_8.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_9.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_10.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_11.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_12.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_13.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_14.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_15.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_16.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_17.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_18.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_19.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_4_20.jpg",
];

function Newsletter3() {
  const flipBookRef = useRef();
  const goToNextPage = () => {
    if (flipBookRef.current) {
      flipBookRef.current.pageFlip().flipNext(); // Call flipNext method
    }
  };

  const goToPreviousPage = () => {
    if (flipBookRef.current) {
      flipBookRef.current.pageFlip().flipPrev(); // Call flipPrev method
    }
  };
  return (
    <>
      <div className="container">
        <div className="row inner-content">
          <div className="col-md-12">
            <div className="flipOpen">
              <HTMLFlipBook
                ref={flipBookRef}
                width={600}
                height={800}
                minWidth={315}
                maxWidth={1000}
                minHeight={400}
                mobileScrollSupport={true}
                showCover={true}
                useMouseEvents={true}
                className="flipPageComponent"
                pageBackground="rgb(255, 255, 255)"
                uncutPages={true}
              >
                {NEWSLETTER_4_IMG.map((img, index) => (
                  <div key={index}>
                    <img src={img} alt={`Page ${index + 1}`} />
                  </div>
                ))}
              </HTMLFlipBook>
            </div>
            <div className="navigation-buttons">
              <button onClick={goToPreviousPage} className="btn btn-primary">
                <i class="bi bi-arrow-left"></i>
              </button>
              <button onClick={goToNextPage} className="btn btn-primary">
                <i class="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Newsletter3;
